<template>
  <div id="app" :class="{ 'dark': themeStore.isDark }" class="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-50 transition-colors duration-300">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useThemeStore } from '@/stores/theme'
import { useI18n } from '@/i18n'

const themeStore = useThemeStore()
const { initLocale } = useI18n()

onMounted(() => {
  // 初始化主题
  themeStore.initTheme()
  // 初始化语言
  initLocale()
})
</script>
